import React from 'react';
import { IconProps } from './types';
import { ReactComponent as DoubleChevronSvg } from '../assets/icons/double-chevron-left.svg';
import clsx from 'clsx';

type DoubleChevronIconProps = {
  dir?: 'left' | 'right' | 'up' | 'down';
};

export const DoubleChevronIcon = ({
  className,
  onClick,
  dir = 'left',
}: IconProps & DoubleChevronIconProps) => (
  <DoubleChevronSvg
    className={clsx(className, {
      'rotate-180': dir === 'right',
      'rotate-90': dir === 'up',
      '-rotate-90': dir === 'down',
    })}
    onClick={onClick}
  />
);

export default DoubleChevronIcon;
